module.exports = __webpack_public_path__ + "static/media/alarmlog-icon.86c57cdf.svg";